import { SearchPage } from 'Components'
import TemplateSearchPage from 'Stores/shopify-pursuit-generic/Templates/SearchPage.rt'
import { FacetTiles } from 'Components'
import TemplatefacetTilessubtitles from 'Stores/_default-store/Templates/facetTiles/subtitles.rt'
import { SearchResult } from 'Components'
import { FacetPanel } from 'Components'
import { FacetBar } from 'Components'
import { VehicleWidget } from 'Components'
import TemplatefitmentSearchcollapsibleVehicleWidget from 'Stores/_default-store/Templates/fitmentSearch/collapsibleVehicleWidget.rt'
import { RequestPanel } from 'Components'
import TemplateHomeWheelTireBar from 'Stores/_default-store/Templates/HomeWheelTireBar.rt'
import { SearchBox } from 'Components'
import TemplateSearchBox from 'Stores/_default-store/Templates/SearchBox.rt'
import { Garage } from 'Components'
import TemplatefitmentSearchgarage from 'Stores/_default-store/Templates/fitmentSearch/garage.rt'
import { SingleVehicleGarage } from 'Components'
import TemplatefitmentSearchsingleVehicleGarage from 'Stores/_default-store/Templates/fitmentSearch/singleVehicleGarage.rt'
import { VerifyFitment } from 'Components'
import TemplatefitmentSearchcollapsibleVerifyFitment from 'Stores/docs-diesel-filters/Templates/fitmentSearch/collapsibleVerifyFitment.rt'
import TemplatefacetTileshierarchicalContainer from 'Stores/docs-diesel-filters/Templates/facetTiles/hierarchicalContainer.rt'
import { RelatedItems } from 'Components'
import TemplateproductrelatedItems from 'Stores/_default-store/Templates/product/relatedItems.rt'
import { BuyItemsTogether } from 'Components'
import TemplateproductboughtTogether from 'Stores/_default-store/Templates/product/boughtTogether.rt'
import { FacetDialog } from 'Components'
import TemplateFacetDialogVehicleSpecs from 'Stores/shopify-pursuit-generic/Templates/FacetDialogVehicleSpecs.rt'
import { SearchBoxDialog } from 'Components'
import TemplateSearchBoxDialog from 'Stores/_default-store/Templates/SearchBoxDialog.rt'
import { SearchHeader } from 'Components'
import TemplatefitmentSearchhomeVehicleWidget from 'Stores/docs-diesel-filters/Templates/fitmentSearch/homeVehicleWidget.rt'
import TemplatefitmentSearchheaderMobileHomeVehicleWidget from 'Stores/docs-diesel-filters/Templates/fitmentSearch/headerMobileHomeVehicleWidget.rt'
import TemplatefitmentSearchheaderVehicleWidget from 'Stores/docs-diesel-filters/Templates/fitmentSearch/headerVehicleWidget.rt'
import TemplatefitmentSearchsidecartVehicleWidgetDialog from 'Stores/docs-diesel-filters/Templates/fitmentSearch/sidecartVehicleWidgetDialog.rt'
import TemplatefitmentSearchstickyVerifyFitment from 'Stores/docs-diesel-filters/Templates/fitmentSearch/stickyVerifyFitment.rt'
import TemplatefacetTilesalphabeticalContainer from 'Stores/_default-store/Templates/facetTiles/alphabeticalContainer.rt'
import { FitmentTable } from 'Components'
import TemplatefitmentSearchfitmentTableTab from 'Stores/docs-diesel-filters/Templates/fitmentSearch/fitmentTableTab.rt'
import TemplatefitmentSearchfitmentTable from 'Stores/docs-diesel-filters/Templates/fitmentSearch/fitmentTable.rt'
import { ProductData } from 'Components'
import TemplateproductinterchangesTab from 'Stores/docs-diesel-filters/Templates/product/interchangesTab.rt'
import Templateproductinterchanges from 'Stores/docs-diesel-filters/Templates/product/interchanges.rt'
import Templateproductspecifications from 'Stores/docs-diesel-filters/Templates/product/specifications.rt'
import { VehicleWidgetDialog } from 'Components'
import TemplatefitmentSearchdialog from 'Stores/_default-store/Templates/fitmentSearch/dialog.rt'
import { ContextDialog } from 'Components'
import TemplateKlaviyoDialog from 'Stores/docs-diesel-filters/Templates/KlaviyoDialog.rt'

export const compMap = {
  SearchPage,
FacetTiles,
SearchResult,
FacetPanel,
FacetBar,
VehicleWidget,
RequestPanel,
SearchBox,
Garage,
SingleVehicleGarage,
VerifyFitment,
RelatedItems,
BuyItemsTogether,
FacetDialog,
SearchBoxDialog,
SearchHeader,
FitmentTable,
ProductData,
VehicleWidgetDialog,
ContextDialog
} 
export const tplMap = {
  'SearchPage': TemplateSearchPage,
'facetTiles/subtitles': TemplatefacetTilessubtitles,
'fitmentSearch/collapsibleVehicleWidget': TemplatefitmentSearchcollapsibleVehicleWidget,
'HomeWheelTireBar': TemplateHomeWheelTireBar,
'SearchBox': TemplateSearchBox,
'fitmentSearch/garage': TemplatefitmentSearchgarage,
'fitmentSearch/singleVehicleGarage': TemplatefitmentSearchsingleVehicleGarage,
'fitmentSearch/collapsibleVerifyFitment': TemplatefitmentSearchcollapsibleVerifyFitment,
'facetTiles/hierarchicalContainer': TemplatefacetTileshierarchicalContainer,
'product/relatedItems': TemplateproductrelatedItems,
'product/boughtTogether': TemplateproductboughtTogether,
'FacetDialogVehicleSpecs': TemplateFacetDialogVehicleSpecs,
'SearchBoxDialog': TemplateSearchBoxDialog,
'fitmentSearch/homeVehicleWidget': TemplatefitmentSearchhomeVehicleWidget,
'fitmentSearch/headerMobileHomeVehicleWidget': TemplatefitmentSearchheaderMobileHomeVehicleWidget,
'fitmentSearch/headerVehicleWidget': TemplatefitmentSearchheaderVehicleWidget,
'fitmentSearch/sidecartVehicleWidgetDialog': TemplatefitmentSearchsidecartVehicleWidgetDialog,
'fitmentSearch/stickyVerifyFitment': TemplatefitmentSearchstickyVerifyFitment,
'facetTiles/alphabeticalContainer': TemplatefacetTilesalphabeticalContainer,
'fitmentSearch/fitmentTableTab': TemplatefitmentSearchfitmentTableTab,
'fitmentSearch/fitmentTable': TemplatefitmentSearchfitmentTable,
'product/interchangesTab': TemplateproductinterchangesTab,
'product/interchanges': Templateproductinterchanges,
'product/specifications': Templateproductspecifications,
'fitmentSearch/dialog': TemplatefitmentSearchdialog,
'KlaviyoDialog': TemplateKlaviyoDialog
};